import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { SsoUserProfile } from '../types/auth';

interface SsoUserState {
  profile: SsoUserProfile | null;
}

const initialState: SsoUserState = { profile: null };

const ssoUserSlice = createSlice({
  name: 'ssoUser',
  initialState,
  reducers: {
    setSsoProfile(state, action: PayloadAction<SsoUserProfile>) {
      state.profile = action.payload;
    },
    clearSsoProfile(state) {
      state.profile = null;
    },
  },
});

export const { setSsoProfile, clearSsoProfile } = ssoUserSlice.actions;
export default ssoUserSlice.reducer;
